@if (grupos().length) {
  <div class="meeting-people">
    @for (grupo of grupos(); track grupo.kind) {
      <div class="meeting-people__group">
        <span
          class="meeting-people__label"
          [class]="'meeting-people__label meeting-people__label--' + grupo.kind">
          {{ grupo.label }} ({{ grupo.participantes.length }})
        </span>
        <ul class="meeting-people__list">
          @for (p of grupo.participantes; track p.id) {
            <li class="meeting-people__chip" [class.meeting-people__chip--absent]="!p.attended">
              <span class="meeting-people__name">
                {{ nome(p) }}
                @if (!p.attended) {
                  <span class="meeting-people__absent">· não entrou</span>
                }
                @if (p.isRecorder) {
                  <span class="meeting-people__absent">· gravador de reunião</span>
                }
              </span>
              @if (p.email && p.email !== nome(p)) {
                <span class="meeting-people__email">{{ p.email }}</span>
              }
              @if (organizacao(p) && grupo.kind !== 'Legatus') {
                <span class="meeting-people__org">{{ organizacao(p) }}</span>
              }
            </li>
          }
        </ul>
      </div>
    }
  </div>
} @else {
  <p class="meeting-people__empty">Nenhum participante registrado.</p>
}
